import { RevButton } from "@revmatics/catalyst";

interface Props {
  onSignIn: () => void;
}

export const AuthErrorState = ({ onSignIn }: Props) => (
  <div className="flex h-dvh flex-col items-center justify-center gap-4 text-center">
    <p className="text-base font-medium text-gray-900">
      Application can&apos;t reach your session — sign in again or contact
      support.
    </p>
    <RevButton text="Sign in" handleClick={onSignIn} />
  </div>
);
